<template>
  <div>
    <div>
      <OuterHeader ref="OuterHeader" @showRegister="showRegister()" />
    </div>
    <main role="main">
      <div class="page-content mt-0">
        <section class="innerpage-banner mb-5 banner-success-stories">
          <div class="container">
            <div class="row align-items-center content-wrap">
              <div class="col-lg-7 col-md-12">
                <h1 class="text-white display-4 font-bold">Success Stories</h1>
              </div>
            </div>
          </div>
        </section>
        <div class="container my-md-5 my-4 mb-4">
          <div class="row">
            <div class="col-lg-3 col-md-6" v-for="(data, index) in list" :key="index">
              <div class="text-center story-img-wrap">
                <img :src="data.image ? data.image : '/img/success-holder.png'"
                  class="img-fluid object-cover rounded img-height" />
              </div>
              <div class="card p-3 border-0 shadow stories-card">
                <p class="mt-5 text-center font-medium text-brand font-14">
                 {{
                    data.groom_details ? data.groom_details.registration_no : ""
                  }}
                  &
                  {{
                    data.bride_details ? data.bride_details.registration_no : ""
                  }}
                </p>
                <div class="mr-bridegroom">

                   <div class="mr-bridegroom-inner">
                    <h4 class="text-center text-uppercase font-14 mb-3 font-medium">
                      {{ data.groom_details ? data.groom_details.first_name : "" }}<br>
                      {{ data.groom_details ? data.groom_details.last_name : "" }}
                    </h4>
                    <p class="font-14">
                      {{ data.groom_address }}
                    </p>
                  </div>
              
                  <h4 class="text-center text-uppercase font-14 mb-3 font-medium">&</h4>
                      <div class="mr-bridegroom-inner">
                    <h4 class="text-center text-uppercase font-14 mb-3 font-medium">
                      {{ data.bride_details ? data.bride_details.first_name : "" }}<br>
                      {{ data.bride_details ? data.bride_details.last_name : "" }}
                    </h4>

                    <p class="font-14">
                      {{ data.bride_address }}
                    </p>
                  </div>
                   
                 
                </div>
                <!-- <h4 class="text-center text-uppercase font-14 mb-3 font-medium">
                  {{ data.bride_details ? data.bride_details.first_name : "" }}
                  {{ data.bride_details ? data.bride_details.last_name : "" }} &
                  {{ data.groom_details ? data.groom_details.first_name : "" }}
                  {{ data.groom_details ? data.groom_details.last_name : "" }}
                </h4> -->
                <!-- <div class="row">
                  <div class="col-md-6">
                    <div class="d-flex align-items-start">
                      <img src="/images/adress.svg" width="25" alt="" />
                      <div class="ms-2">
                        <p class="font-14">
                          {{ data.bride_address }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="d-flex align-items-start">
                      <img src="/images/adress.svg" width="25" alt="" />
                      <div class="ms-2">
                        <p class="font-14">
                          {{ data.groom_address }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
            <!-- <div class="col-lg-4 col-md-6">
              <div class="text-center story-img-wrap">
                <img
                  src="images/couple-2.jpg"
                  class="img-fluid object-cover rounded"
                  width="380"
                  height="350"
                  alt="Photo"
                />
              </div>
              <div class="card p-3 border-0 shadow stories-card">
                <p class="font-18 mt-5 text-center font-medium text-brand">
                  099585 & 895698
                </p>
                <h4 class="text-center text-uppercase font-14 mb-3 font-medium">
                  Rina Marathe & Ranjeet Sirsath
                </h4>
                <div class="row">
                  <div class="col-md-6">
                    <div class="d-flex align-items-start">
                      <img src="images/adress.svg" width="25" alt="" />
                      <div class="ms-2">
                        <p class="font-14">
                          Mayur Colony, Kotharud, Pune - 411017 (Maharashtra)
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="d-flex align-items-start">
                      <img src="images/adress.svg" width="25" alt="" />
                      <div class="ms-2">
                        <p class="font-14">
                          Jyotiba Nagar, belva, Karad, Satara - 411017 (Maharashtra)
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>-->
            <!-- <div class="col-lg-4 col-md-6">
              <div class="text-center story-img-wrap">
                <img
                  src="images/couple-3.jpg"
                  class="img-fluid object-cover rounded"
                  width="380"
                  height="350"
                  alt="Photo"
                />
              </div>
              <div class="card p-3 border-0 shadow stories-card">
                <p class="font-18 mt-5 text-center font-medium text-brand">
                  099585 & 895698
                </p>
                <h4 class="text-center text-uppercase font-14 mb-3 font-medium">
                  Anushka Pawar & Rajesh Gawale
                </h4>
                <div class="row">
                  <div class="col-md-6">
                    <div class="d-flex align-items-start">
                      <img src="images/adress.svg" width="25" alt="" />
                      <div class="ms-2">
                        <p class="font-14">
                          Mayur Colony, Kotharud, Pune - 411017 (Maharashtra)
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="d-flex align-items-start">
                      <img src="images/adress.svg" width="25" alt="" />
                      <div class="ms-2">
                        <p class="font-14">
                          Jyotiba Nagar, belva, Karad, Satara - 411017 (Maharashtra)
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>  -->
            <div class="row mx-0 mb-4">
              <div class="col-lg-12 mt-5 text-center">
                <div class="page-bottom-pagination text-right">
                  <Pagination @page-change="pageChange" @items-per-page-change="itemsPerPageChange"
                    ref="listPagination" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
     <SubFooter  ref="SubFooter" @showRegister="showRegister()"/>
     <SignUp ref="signupModal" />

    <MainFooter />
  </div>
</template>
<script>
import OuterHeader from "@/components/OuterHeader";
import MainFooter from "@/components/MainFooter";
import SubFooter from "@/components/SubFooter";
import Pagination from "@/components/Pagination";
 import SignUp from "../../components/signup.vue";
export default {
  name: "SuccessStories",
  components: {
    OuterHeader,
    MainFooter,
    SubFooter,
    Pagination,
    SignUp,
  },
  data() {
    return {
      searchObj: {},
      list: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.$api
        .getAPI({
          _action: "/success-stories",
        })
        .then((res) => {
          this.list = res.list;
        })
        .catch(() => { });
    },
     showRegister() {
      this.$refs.signupModal.showModal();
    },
  },
};
</script>
